<template>
    <div class="content-wrapper">
        <PageHeader :screenName="'Editar ' + tituloNome" :linkItems="linkItems" />

        <ConfirmModal itemIdentifier="usuário" :modalShow="modal.showModal" :typeModal="modal.typeModal"
            @confirmed="redirecionarLista" @canceled="closeModalConfirm" />

        <SucessoModal :modalShow="modalSucesso.showModal" :typeModal="modalSucesso.typeModal"
            :caseModal="modalSucesso.caseModal" @confirmed="redirecionarLista" />

        <ErrorModal :modalShow="modalError.showModal" :typeModal="modalError.typeModal"
            :caseModal="modalError.caseModal" @confirmed="redirecionarLista" />

        <main class="card p-2">
            <section class="form">
                <validation-observer ref="doseRules">
                    <b-form>
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <b-form-group label="Código da Dose*" label-for="codigo-dose-input"
                                    label-class="label_size_dose">
                                    <validation-provider #default="{ errors }" name="CodigoDose" rules="required">
                                        <b-form-input :state="errors.length > 0 || form.errorApi.br_dose ? false : null"
                                            id="codigo-dose-input" disabled v-model="form.codigo" placeholder="Ex: 1"
                                            v-mask="'##########'" />
                                        <small class="text-muted">
                                            Códido cadastrado no BRDose - RNDS CodeSystem.
                                        </small>
                                        <br>
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.codigo" class="text-danger">
                                            {{ form.errorApi.br_dose }}
                                        </small>
                                        <small v-if="form.errorApi.codigo" class="text-danger">
                                            {{ form.errorApi.error }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="6" md="6" sm="12">
                                <b-form-group label="Nome da Dose*" label-for="descricao-input"
                                    label-class="label_size_dose">
                                    <validation-provider #default="{ errors }" name="DescricaoDose" rules="required">
                                        <b-form-input
                                            :state="errors.length > 0 || form.errorApi.descricao || form.errorApi.error ? false : null"
                                            id="descricao-dose-input" v-model="form.descricao"
                                            placeholder="Ex: 1ª Dose, Reforço, Dose Adicional"
                                            v-mask="('X'.repeat(255))" />
                                        <small class="text-muted">
                                            Nome cadastrado no BRDose - RNDS CodeSystem.
                                        </small>
                                        <br>
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.descricao" class="text-danger">
                                            {{ form.errorApi.descricao }}
                                        </small>
                                        <small v-if="form.errorApi.error" class="text-danger">
                                            {{ form.errorApi.error }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <validation-provider #default="{ errors }" name="StatusDose" rules="required">
                                    <b-form-group label="Status*" label-for="status-dose-input"
                                        label-class="label_size_dose" :state="errors.length > 0 ||
                                            form.errorApi.ativo
                                            ? false
                                            : null
                                            ">
                                        <v-select id="status-dose-input" v-model="form.status" :options="statusOptions"
                                            label="label" :reduce="option => option.value"
                                            placeholder="Selecione o status" :clearable="false">
                                            <span slot="no-options">Nenhuma opção selecionável.</span>
                                        </v-select>
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.ativo" class="text-danger">
                                            {{ form.errorApi.ativo }}
                                        </small>
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </section>
            <section class="buttons">
                <b-button id="save-dose" class="mr-2 mt-3 botao_responsivo" variant="custom-blue"
                    @click.prevent="validationForm(true)" :disabled="saving">
                    <feather-icon icon="CheckIcon" class="mr-50" />
                    <span class="align-middle">Salvar alterações</span>
                    <output v-if="saving" aria-live="polite" class="ml-1">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span class="visually-hidden">Salvando...</span>
                    </output>
                </b-button>
                <b-button id="cancel-edit-dose" :disabled="saving" variant="outline-danger"
                    @click.prevent="openModalConfirm" class="mt-3">
                    <feather-icon icon="XIcon" class="mr-50" />
                    <span class="align-middle">Cancelar</span>
                </b-button>
            </section>
        </main>
    </div>
</template>

<script>
import { BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadio, BButton, BFormTextarea, VBTooltip } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue'
import ConfirmModal from '@/views/components/custom/modals/ConfirmModal.vue'
import SucessoModal from '@/views/components/custom/modals/SucessoCriacaoEdicaoModal.vue'
import ErrorModal from '@/views/components/custom/modals/ErroIdInexistenteModal.vue'
import handleErrorsService from './Services/HandleErrors'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { getIdDose } from '@core/utils/store/getStore';
import { setIdDose } from '@core/utils/store/setStore';

export default {
    title: 'Editar dose',

    components: {
        BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadio, BFormTextarea,
        BButton, vSelect, ValidationProvider, ValidationObserver,
        PageHeader, ConfirmModal, SucessoModal, ErrorModal, VuePerfectScrollbar
    },

    directives: {
        'b-tooltip': VBTooltip
    },

    data() {
        return {
            settings: {
                maxScrollbarLength: 70,
                wheelSpeed: 0.2,
                wheelPropagation: false
            },
            linkItems: [
                {
                    name: 'Doses',
                    routeName: 'dose-list'
                },
                {
                    name: 'Editar',
                    active: true
                }
            ],
            modal: {
                showModal: false,
                typeModal: 'danger'
            },
            statusOptions: [
                { label: 'Ativo', value: true },
                { label: 'Inativo', value: false }
            ],
            modalSucesso: {
                showModal: false,
                typeModal: 'success',
                caseModal: 'edicao'
            },
            modalError: {
                showModal: false,
                typeModal: 'error',
                caseModal: 'idInexistente'
            },
            required,
            saving: false,
            form: {
                descricao: '',
                codigo: '',
                status: '',
                errorApi: {
                    descricao: '',
                    codigo: '',
                    status: '',
                    error: ''
                }
            },
            idDoseEditar: null,
            tituloNome: '',
        }
    },

    mounted() {
        const hasModalError = this.$helpers.verifyIfCanOpenModalError(getIdDose(), this.$route.params.idDose);
        const hasIdEntityRouteParam = this.$helpers.verifyIfHasIdEntityRouteParam(getIdDose(), this.$route.params.idDose);

        if (hasModalError)
            return this.openModalError();

        if (hasIdEntityRouteParam) {
            setIdDose(this.$route.params.idDose);
        }

        this.$http.get(this.$api.doseWithParameter(getIdDose())).then(({ data }) => {
            this.preenchimentoFormulario(data);
        });
    },

    methods: {
        validationForm(redirectToList) {
            this.$refs.doseRules.validate().then(success => {
                if (success) {
                    if (redirectToList) {
                        this.saving = true;
                    }
                    this.editDose(redirectToList);
                }
            })
        },

        editDose(redirectToList) {
            const parameters = {
                'descricao': this.form.descricao,
                'br_dose': this.form.codigo,
                'ativo': this.form.status
            }

            this.$http.put(this.$api.doseWithParameter(this.idDoseEditar), parameters).then(() => {
                if (redirectToList) {
                    this.openModalSucesso();
                }

                this.saving = false;
                this.cleanForm();

            }).catch(({ response: { data } }) => {
                handleErrorsService.handleErrosDose(data, this.form.errorApi);

                this.saving = false;
            })
        },

        cleanForm() {
            this.form.descricao = '';
            this.form.codigo = '';
            this.form.status = '';

            this.form.errorApi.descricao = '';
            this.form.errorApi.codigo = '';
            this.form.errorApi.status = '';
            this.form.errorApi.error = ''

            this.$refs.doseRules.reset();
        },

        preenchimentoFormulario(dados) {
            this.idDoseEditar = dados.id_dose;
            this.form.descricao = dados.descricao;
            this.form.codigo = dados.br_dose;
            this.form.status = dados.ativo;
            this.linkItems[1].name = 'Editar ' + dados.descricao;
            this.tituloNome = dados.descricao;
        },

        openModalConfirm() {
            this.modal.showModal = true;
        },

        closeModalConfirm() {
            this.modal.showModal = false;
        },

        openModalSucesso() {
            this.modalSucesso.showModal = true;
        },

        openModalError() {
            this.modalError.showModal = true;
        },

        redirecionarLista() {
            this.$router.push({ name: 'dose-list' });
        }
    }
}
</script>

<style scoped>
@media (max-width: 768px) {
    .buttons {
        text-align: center;
    }

    .botao_responsivo {
        margin-left: 1.25rem;
    }
}
</style>